import { render } from "./Kanban.vue?vue&type=template&id=5c88bab4&scoped=true"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"

import "./Kanban.vue?vue&type=style&index=0&id=5c88bab4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5c88bab4"

export default script